import yxpapi from '@yxpapi';

let apis = new yxpapi.JAVAAPI({
    /* 获取列表 */
    getList: {
        url: '/api/permit/permission/getPermitObjectList',
        method: 'get',
    // options: {
    //   auth: false
    // }
    },
    /* 删除权限对象 */
    delete: {
        url: '/api/permit/permission/deletePermitObject',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    /* 修改权限对象 */
    updata: {
        url: '/api/permit/permission/addOrUpdate',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    /* 获取权限模块 */
    getActionList: {
        url: '/api/permit/permission/getActionList',
        method: 'get',
    },
    /* 修改权限 */
    changeAuthori: {
        url: '/api/permit/permission/grantAuthorization',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    /* 获取用户的权限列表 */
    getUserModuleActionList: {
        url: '/api/permit/permission/getUserModuleActionList',
        method: 'get',
    },
    /* 获取部门列表 1 xx */
    getApartmentLists: {
        url: '/api/user/address/department/list',
        method: 'get',
    },
    /* 获取角色组 1 */
    getRoleGroups: {
        url: '/api/user/address/role/listGroup',
        method: 'get',
    },
    /* 获取部门成员 3 xx */
    getUsers: {
        url: '/api/user/address/department/listUser',
        method: 'get',
    },
    /* 关键字查找 部门 成员 角色 20 */
    search: {
        url: '/api/user/address/search',
        method: 'get',
    },
});
export default apis;
